module.exports = __webpack_public_path__ + "static/media/004.184a5d7c.png";